import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'

export default class Modalarticletyps extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.props.updateat();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
  }

  handleChange(event) {    this.setState({inside: event.target.value});  }
  handleChange2(event) {    this.setState({faculty: event.target.value});  }

  handleSubmit(event) {
    // alert('A name was submitted: ' + this.state.value);
      event.preventDefault();
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("inside", this.state.inside);
      datafrm.append("faculty", this.state.faculty);
      datafrm.append("idsend", this.props.id_send);


 Axios
 // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
  // .post("https://conference.kpru.ac.th/PHPAPI/updatearticle.php",datafrm)
    .post("https://edu.kpru.ac.th/conference/PHPAPI/updatearticle.php",datafrm)
   .then(res => {
     console.log("response: ", res)

     if (res.data.status = 'success888') {
   
      Swal.fire({
       title: 'เลือกคณะสำเร็จ',
       text: "Successfully selected faculty",
       icon: 'success',
       showCancelButton: false,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
       confirmButtonText: 'ตกลง'
     }).then((result) => {
       if (result.isConfirmed) {
           this.props.updateat()
           this.toggle()
       }
     })
     
     }else{
           message.error("อัพโหลไฟล์ไม่สำเร็จ!")
     }

  })

  this.props.updateat();
  this.toggle()


  }

  

    render() {
        return (
            <MDBContainer>
            <MDBBtn onClick={this.toggle}>จัดการ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>{this.props.namearticla}</MDBModalHeader>
              <MDBModalBody>
              <div>
              <div>
        <p>ภายใน/ภายนอก{this.state.A1}</p>
        <select label="Example label" className="browser-default custom-select" onChange={this.handleChange} >
          <option>กรุณาเลือกสถานะ</option>
          <option value="1">ภายใน</option>
          <option value="2">ภายนอก</option>
        </select>
       </div><br/>
       <p>เลือกคณะ{this.state.A2}</p>
        <select className="browser-default custom-select" onChange={this.handleChange2}>
                   <option>กรุณาเลือกคณะ</option>
                   <option value="1">คณะครุศาสตร์</option>
                   {/* <option value="2">คณะวิทยาศาสตร์และเทคโนโลยี</option>
                   <option value="3">คณะมนุษยศาสตร์และสังคมศาสตร์</option>
                   <option value="4">คณะวิทยาการจัดการ</option>
                   <option value="5">คณะเทคโนโลยีอุตสาหกรรม</option>
                   <option value="6">คณะพยาบาลศาสตร์</option>
                   <option value="7">มรภ.กพ แม่สอด</option> */}
        </select>
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ยกเลิก</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
        )
    }
}
